/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { RuleType } from './RuleType.js';
import {
    RuleTypeFromJSON,
    RuleTypeFromJSONTyped,
    RuleTypeToJSON,
} from './RuleType.js';

/**
 * 
 * @export
 * @interface UpdateRuleRequest
 */
export interface UpdateRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateRuleRequest
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateRuleRequest
     */
    maxScore?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRuleRequest
     */
    isManual?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRuleRequest
     */
    isGlobal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRuleRequest
     */
    isScriptAdherence?: boolean;
    /**
     * 
     * @type {RuleType}
     * @memberof UpdateRuleRequest
     */
    type?: RuleType;
    /**
     * 
     * @type {string}
     * @memberof UpdateRuleRequest
     */
    scriptContent?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateRuleRequest
     */
    sectionId?: number;
}

/**
 * Check if a given object implements the UpdateRuleRequest interface.
 */
export function instanceOfUpdateRuleRequest(value: object): boolean {
    return true;
}

export function UpdateRuleRequestFromJSON(json: any): UpdateRuleRequest {
    return UpdateRuleRequestFromJSONTyped(json, false);
}

export function UpdateRuleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRuleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'maxScore': json['maxScore'] == null ? undefined : json['maxScore'],
        'isManual': json['isManual'] == null ? undefined : json['isManual'],
        'isGlobal': json['isGlobal'] == null ? undefined : json['isGlobal'],
        'isScriptAdherence': json['isScriptAdherence'] == null ? undefined : json['isScriptAdherence'],
        'type': json['type'] == null ? undefined : RuleTypeFromJSON(json['type']),
        'scriptContent': json['scriptContent'] == null ? undefined : json['scriptContent'],
        'sectionId': json['sectionId'] == null ? undefined : json['sectionId'],
    };
}

export function UpdateRuleRequestToJSON(value?: UpdateRuleRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'maxScore': value['maxScore'],
        'isManual': value['isManual'],
        'isGlobal': value['isGlobal'],
        'isScriptAdherence': value['isScriptAdherence'],
        'type': RuleTypeToJSON(value['type']),
        'scriptContent': value['scriptContent'],
        'sectionId': value['sectionId'],
    };
}

